import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface ISeasonTicketCountResponse {
  current_unexchanged_tickets: number;
  has_grantable_random_items_remaining: boolean;
}

export default function useFetchSeasonTicketCount(): UseQueryResult<
  ISeasonTicketCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<ISeasonTicketCountResponse>(
    ["seasonTicketCount"],
    async (): Promise<ISeasonTicketCountResponse> => {
      return await axios.get(`/v1/season/tickets/count`).then((r) => {
        return r.data as ISeasonTicketCountResponse;
      });
    }
  );

  return query;
}
